module.exports = __webpack_public_path__ + "img/ico-viber.bd9ae38c.svg";